export const assetShareUrl = (data, origin = process.env.REACT_APP_BACKEND_URL) => {
  if (!/^\/a\/[A-Za-z0-9_-]{22}$/.test(data.path || '')) throw new Error('Enlace no válido');
  const base = new URL(origin);
  if (base.protocol !== 'https:' || base.username || base.password) throw new Error('El dominio público debe ser HTTPS');
  return new URL(data.path, base.origin).href;
};

export const copyShareText = async text => {
  try { await navigator.clipboard.writeText(text); }
  catch (_) {
    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('data-testid', 'asset-share-clipboard-fallback');
    input.setAttribute('aria-label', 'Texto para compartir el activo');
    Object.assign(input.style, { position: 'fixed', opacity: '0', width: '1px' });
    document.body.appendChild(input); input.select();
    try { if (!document.execCommand('copy')) throw new Error('clipboard'); }
    finally { input.remove(); }
  }
};